module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-pure.js
// module id = 19
// module chunks = 1